import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown/UnitType?status=1";

export default class UnitTypesService {
    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
      }
   

}
